import { render, staticRenderFns } from "./aigcTheme.vue?vue&type=template&id=8e9f0290&scoped=true&"
import script from "./aigcTheme.vue?vue&type=script&lang=js&"
export * from "./aigcTheme.vue?vue&type=script&lang=js&"
import style0 from "./aigcTheme.vue?vue&type=style&index=0&id=8e9f0290&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9f0290",
  null
  
)

export default component.exports